module.exports = __webpack_public_path__ + "b3ee840eec430498727248e8dcb51680.svg";